'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/syntax.js
// module id = 263
// module chunks = 0